import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { Heading, TextLink, Text } from '@frontend/design-system';

type Props = {
  headerText?: string;
  onClickText?: string;
  onClick?: () => void;
  level?: 'primary' | 'secondary';
  disabled?: boolean;
};

export const FilterGroupHeader = ({ headerText, onClick, onClickText, level = 'secondary', disabled }: Props) => {
  return (
    <motion.section
      css={css`
        display: flex;
        justify-content: space-between;
        margin-bottom: ${level === 'secondary' ? theme.spacing(2) : theme.spacing(1)};
        gap: ${theme.spacing(2)};
      `}
    >
      {headerText && level === 'primary' && (
        <Heading
          level={3}
          css={css`
            margin: 0;
            font-size: ${theme.fontSize(16)};
          `}
        >
          {headerText}
        </Heading>
      )}
      {headerText && level === 'secondary' && (
        <Text
          css={css`
            margin: 0;
          `}
          weight='semibold'
        >
          {headerText}
        </Text>
      )}
      <TextLink weight='bold' onClick={onClick} disabled={disabled} css={{ marginLeft: 'auto' }}>
        {onClickText}
      </TextLink>
    </motion.section>
  );
};
